__turbopack_context__.v({
  "alertsTitle": "questionAlerts-module-scss-module__kggI4W__alertsTitle",
  "bottomSection": "questionAlerts-module-scss-module__kggI4W__bottomSection",
  "container": "questionAlerts-module-scss-module__kggI4W__container",
  "title": "questionAlerts-module-scss-module__kggI4W__title",
  "wrapper": "questionAlerts-module-scss-module__kggI4W__wrapper",
});
